import { computed, type ComputedRef, type ToRefs } from "vue";
import { useSharedState } from "composables/useSharedState";
import type { CheckboxGroupProps } from "./checkbox.types";
import { checkboxGroupClasses } from "./checkbox.styles";

export interface UseCheckboxGroupOptions {
  props: Readonly<CheckboxGroupProps>;
}

export interface UseCheckboxGroupReturn {
  state: ToRefs<CheckboxGroupProps>;
  classes: ComputedRef<ReturnType<typeof checkboxGroupClasses>>;
  ariaDisabled: ComputedRef<true | undefined>;
}

export const useCheckboxGroup = (options: UseCheckboxGroupOptions): UseCheckboxGroupReturn => {
  const state = useSharedState(options.props);
  const classes = computed(() => checkboxGroupClasses({ disabled: state.disabled?.value }));
  const ariaDisabled = computed<true | undefined>(() => (state.disabled?.value ? true : undefined));
  return { state, classes, ariaDisabled };
};
